import { render } from "./HelpMfaSettingEn.vue?vue&type=template&id=9494d606"
const script = {}

import "./HelpMfaSettingEn.vue?vue&type=style&index=0&id=9494d606&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__